exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n[dir] body {\n  background: #fff;\n}\n", "", {"version":3,"sources":["/var/www/html/pages/_lang/download-app/successful-download-app.vue"],"names":[],"mappings":";AACA;EACE,iBAAiB;CAClB","file":"successful-download-app.vue","sourcesContent":["\n[dir] body {\n  background: #fff;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-758dce37","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/_lang/download-app/successful-download-app.vue
// module id = ./node_modules/css-loader/index.js?{"sourceMap":true,"minimize":false,"importLoaders":0,"alias":{"/assets":"/var/www/html/assets","/static":"/var/www/html/static"}}!./node_modules/vue-loader/lib/style-compiler/index.js?{"vue":true,"id":"data-v-758dce37","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/_lang/download-app/successful-download-app.vue
// module chunks = 43